// src/pages/NotFoundPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

const NotFoundPage: React.FC = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-box">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">Page not found</p>
        <Link to="/" className="notfound-button">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
